/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { isMobile } from '../../util/mobile-detect';
import { audioPlugins, videoPlugins } from '../../plugins';
import BNNVARAMediaPlayer from '../BNNVARAMediaPlayer/BNNVARAMediaPlayer';
import NPOVideoPlayer from '../NPOVideoPlayer/NPOVideoPlayer';
import fallBackPoster from '../../assets/placeholder.jpg';

export const BNNVARA_VIDEO_PLAYER_TYPE = 'video';
export const NPO_VIDEO_PLAYER_TYPE = 'npo';
export const BNNVARA_AUDIO_PLAYER_TYPE = 'audio';

const isAudioOrVideoOrNpo = typeMedia =>
  !!(
    typeMedia === BNNVARA_AUDIO_PLAYER_TYPE ||
    typeMedia === BNNVARA_VIDEO_PLAYER_TYPE ||
    typeMedia === NPO_VIDEO_PLAYER_TYPE
  );

const MediaPlayer = ({
  embedId,
  type,
  source,
  poster,
  title,
  programTitle,
  subtitles,
  genres,
  broadcasters,
  mediaId,
  classifications,
  duration,
  recommendations,
  cta,
  userId = false,
  isFallback = false,
}) => {
  /**
   * Check if it's one of the know types
   */
  if (!isAudioOrVideoOrNpo(type))
    return 'Oeps dit type media is niet bekend bij ons';

  /**
   * Render NPO player
   */
  if (type === NPO_VIDEO_PLAYER_TYPE) {
    return <NPOVideoPlayer embedId={embedId} title={title} />;
  }

  /**
   * Render remaining types Video and Audio
   */
  const searchParams = new URLSearchParams(window.location.search);
  const vertical = !!searchParams.get('vertical');

  return (
    <BNNVARAMediaPlayer
      cta={cta}
      mediaId={mediaId}
      vertical={vertical}
      source={source}
      duration={duration}
      poster={poster}
      loadingPosterImage={
        type === BNNVARA_VIDEO_PLAYER_TYPE ? fallBackPoster : null
      }
      isMobile={isMobile()}
      title={title}
      programTitle={programTitle}
      subtitles={subtitles}
      broadcasters={broadcasters}
      plugins={type === BNNVARA_AUDIO_PLAYER_TYPE ? audioPlugins : videoPlugins}
      genres={genres}
      classifications={classifications}
      type={type === BNNVARA_AUDIO_PLAYER_TYPE ? 'audio' : 'video'}
      recommendations={recommendations}
      userId={userId}
      isFallback={isFallback}
    />
  );
};

MediaPlayer.defaultProps = {
  type: BNNVARA_VIDEO_PLAYER_TYPE,
  isFallback: false,
};

// TODO: write all propTypes
MediaPlayer.propTypes = {
  type: PropTypes.oneOf([
    BNNVARA_VIDEO_PLAYER_TYPE,
    NPO_VIDEO_PLAYER_TYPE,
    BNNVARA_AUDIO_PLAYER_TYPE,
  ]),
  isFallback: PropTypes.bool,
};

export default MediaPlayer;
